// extracted by mini-css-extract-plugin
export default {"messages":"style_messages__2B3+i","message":"style_message__lcBaM"};